<ng-template #templateUserValidationModal>
    <div class="modal-user-validation">
        <div class="modal-header">
            <div class="d-flex flex-column">
                <h4 class="modal-title">{{ 'geral.user-validation.header.title' | translate }}</h4>
                <span class="modal-subtitle">
                    <span>{{ 'geral.user-validation.header.subtitle' | translate }}</span>
                </span>
            </div>
            @if (enableUserVerificationCloseButton || currentStep == navigationStepList.length) {
                <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="close();"></button>
            }
        </div>
        <div class="modal-body">
            <div class="content">
                <div class="navigation">
                    @for (navigationStep of navigationStepList; track $index; let index = $index) {
                        <div [ngClass]="{ 'active': index === currentStep, 'regular-opacity': index <= currentStep}">
                            <span class="step-number">{{ index + 1 }}</span>
                            <span class="step-text">{{ navigationStep | translate }}</span>
                        </div>
                        @if (index < navigationStepList.length - 1) {
                            <i-feather name="chevron-right"></i-feather>
                        }
                    }
                </div>

                @switch (currentStep) {
                    @case (0) {
                        <app-user-data-validation [user]="user" (onNextStepClick)="changeStep()" />
                    }
                    @case (navigationStepList.length) {
                        <app-user-end-validation (onCloseModalClick)="close()" />
                    }
                    @default {
                        <app-user-email-whatsapp-validation [user]="user" [isWhatsapp]="isWhatsapp" (onNextStepClick)="changeStep()" />
                    }
                }
            </div>
            <div class="logout-section">
                <span (click)="logout()">{{ 'geral.user-validation.footer.logout.title' | translate }}</span>
            </div>
        </div>
    </div>
    <ngx-ui-loader [loaderId]="'loader-user-validation'"></ngx-ui-loader>
</ng-template>
